import type { TFunction } from "i18next";

export function workflowTaskTitle(title: string, t: TFunction): string {
  const match = title.match(/^Approval Required:\s*(.+)$/);
  if (!match) return title;
  return match[1] === "HR Approval" ? t("pilot.task.hrApproval") : t("pilot.task.approval", { name: match[1] });
}
export function workflowTaskDescription(description: string | null | undefined, t: TFunction): string {
  return description === "Review the expense details and approve or reject it." ? t("pilot.task.expenseReview") : description ?? "";
}
